import { useEffect, useState } from "react";
import Confetti from "react-dom-confetti";
import { useTranslation } from "react-i18next";
import Button from "src/components/Button";
import Card from "src/components/Card";
import useGet from "src/hooks/rest/useGet";
import useAuth from "src/hooks/selectors/useAuth";

const CompanyGiftCard = () => {
	const [{ data }, loading] = useGet("/company/gifts");
	const count = Number(data?.value || 0) - Number(data?.used || 0);
	const [showConfetti, setShowConfetti] = useState(false);
	const auth = useAuth();
	const { t } = useTranslation("tasks");

	useEffect(() => {
		if (!loading && !showConfetti) {
			setShowConfetti(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loading]);

	return (
		<Card>
			<div className="flex items-center gap-8">
				<h1 className="text-[90px]">
					<Confetti active={showConfetti} />
					🎁
				</h1>
				<div className="flex flex-col gap-4">
					<h2>{t("gift.title")}</h2>
					<p className="mb-0">
						{t("gift.description", {
							count: count || 1,
						})}
					</p>
					<div className="flex ">
						<Button
							to={
								auth.has_subscription
									? "/tasks/create"
									: "/subscription"
							}
						>
							{t("gift.cta", {
								count: count || 1,
							})}
						</Button>
						<Confetti active={showConfetti} />
					</div>
				</div>
			</div>
		</Card>
	);
};

export default CompanyGiftCard;
